import { PriceDetails, Tariff } from 'api/billing/fetchTariffsApi'
import { ProductsType } from 'components/storefront/payment/PriceSection'
import {
  FREE_TARIFF,
  MambaCurrency,
} from 'components/storefront/StoreFront.constants'
import { Gift } from 'reducers/storefront/StoreFrontGiftsState'

export const hasFiatCurrencyInstantPayment = (tariff: Tariff) =>
  tariff?.instantPayment && hasFiatCurrency(tariff?.instantPayment)

export const hasFiatCurrency = (paymentDetails?: PriceDetails) =>
  paymentDetails?.currency !== MambaCurrency

export const isFreeGift = (gift: Gift) =>
  gift.free || gift.tariff === FREE_TARIFF

export const findTariff = (product: ProductsType, tariffs: Tariff[]) => {
  if (product) {
    const tariff = tariffs.find(({ tariff }) => tariff === product.tariff)
    if (tariff) {
      return tariff
    }
  }
  return null
}

export const hasProductInstantPayment = (
  product: ProductsType,
  tariffs: Tariff[]
) => {
  if (product) {
    const tariff = findTariff(product, tariffs)
    if (tariff) {
      return hasFiatCurrencyInstantPayment(tariff)
    }
  }
  return false
}

export const hasProductOfferPrice = (
  product: ProductsType,
  tariffs: Tariff[]
) => {
  if (product) {
    const tariff = findTariff(product, tariffs)
    if (tariff) {
      return Boolean(tariff.offerPrice)
    }
  }
  return false
}

export const hasInstantPrice = (tariff: Tariff | undefined): boolean =>
  Boolean(tariff?.instantPayment?.currency)
